import { createFileRoute } from '@tanstack/react-router'
import { ExportRequestTracker } from '../../../../features/admin/ExportRequestTracker'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/compliance/exports')({
  component: AdminComplianceExportsRoute,
})

/* ───── Route Component ───── */

function AdminComplianceExportsRoute() {
  return <ExportRequestTracker />
}
